<template lang="pug">
  .dropdown.dropdown-menu.dropdown-menu-right.goq-apps(
    :class="{show: flag}",
    aria-labelledby="js-appsToggleBtn"
  )
    .goq-apps__wrapper
      ul.list-unstyled.goq-apps__list
        li.goq-apps__item(
          v-for="item in appList",
          :key="item.href"
        )
          a.goq-apps__link(
            :href="item.href",
            target="_blank"
          )
            img.img-fluid.goq-apps__img(
              :src="`/static/img/app/app-${item.img}@2x.png`",
              :alt="item.name"
            )
            dl.mb-0.font-weight-bold.goq-apps__dl
              dt.py-2.d-flex.align-items-center.goq-apps__term
                img.goq-apps__icon(
                  :src="`/static/img/app/favicon-${item.favicon}.svg`",
                  alt=""
                )
                | {{ item.name }}
              dd.mb-0
                | {{ item.description }}
</template>

<script>
import appList from './variables'

export default {
  name: 'GoQApps',
  data () {
    return {
      appList
    }
  },
  computed: {
    flag () {
      return this.$store.state.showApps
    }
  }
}
</script>
